import React, { useState } from "react";
import { Collapse } from "reactstrap";

const CollapsibleSection = (props) => {
  const {
    title,
    children,
  } = props;

  const [isOpen, setIsOpen] = useState(true);
  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="mb-4 border rounded p-3">
      <div
        onClick={toggle}
        style={{ cursor: "pointer" }}
        className="d-flex justify-content-between align-items-center"
      >
        <h5 className="mb-0">{title}</h5>     
        <span>{isOpen ? "▲" : "▼"}</span>
      </div>
      <Collapse isOpen={isOpen}>
        <div className="mt-3">
          {children}
        </div>
      </Collapse>
    </div>
  )
};

export default CollapsibleSection;